import React from 'react';

import { FEATURES } from '../../../../common/utils/constants/constants';
import { checkFeatureEnabled } from '../../../../common/utils/helpers/features';
import BuildingLayer from '../building-layer/BuildingLayer';
import POILayer from '../poi-layer/POILayer';
import RoadLayer from '../road-layer/RoadLayer';

const InteractiveLayers = () => (
  <>
    {checkFeatureEnabled(FEATURES.CLICKABLE_BUILDINGS) && <BuildingLayer />}
    {checkFeatureEnabled(FEATURES.ROADS_EDIT) && <RoadLayer />}
    <POILayer />
  </>
);

export default InteractiveLayers;
